/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

const CENTER_GRAPH = "centerGraph";
const SELECTED_JOB = "selectedJob";
const LAST_DEFINITION_CHANGES_DATA = "lastDefinitonChangesData";
const WORKSTATION_JOBS_DETAILS = "workstationJobsDetails";
const LAST_TEN_RUNS_TABLE = "lastTenRunsTable";
const LAST_TEN_RUNS_CHART = "lastTenRunsChart";
const DATA_CHART_START_TIME = "dataChartStartTime";
const DATA_CHART_DURATION = "dataChartDuration";
const CURRENT_JOB_LOG = "currentJobLog";

module.exports = {
    CENTER_GRAPH,
    LAST_DEFINITION_CHANGES_DATA,
    WORKSTATION_JOBS_DETAILS,
    LAST_TEN_RUNS_TABLE,
    LAST_TEN_RUNS_CHART,
    DATA_CHART_START_TIME,
    DATA_CHART_DURATION,
    CURRENT_JOB_LOG,
    SELECTED_JOB
}